export default "__VITE_ASSET__1f4a0e2f__"